module.exports = __webpack_public_path__ + "img/image_19.c4bd5933.png";